import React from "react";

import { NavigationBar } from "../../../helper";

import "../../../assets/stlyes/SubjectOverView/ClassElement.scss";

const ClassElement = (props) => {
  const { markingData } = props;
  return (
    <div className="class-element-main">
      <>
        {/* <img src={lightIcon} alt="icon" className="icon-Light" /> */}
        <span className="classname">{markingData.className}</span>
        <span className="subject">{markingData.subjectName} {NavigationBar.Overview}</span>
      </>
    </div>
  );
}

export { ClassElement };